import { v4 as uuidv4 } from 'uuid';

export const fetchOptions = {
  mode: 'cors',
  credentials: 'include',
  'one-data-correlation-id': uuidv4(),
};

export const readUserSession = async (faasApiUrl, fetchClient = fetch) => {
  const response = await fetchClient(`${faasApiUrl}/ReadUserSession.v1`, fetchOptions);
  return !!response.ok;
};
